import LandingPageLoyaltyAirportTransfersTile from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyAirportTransfersTile'
import LandingPageLoyaltyDiscountedInsurance from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyDiscountedInsurance'
import LandingPageLoyaltyHotelUpgrade from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyHotelUpgrade'
import LandingPageLoyaltyLoungePass from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyLoungePass'
import LandingPageLoyaltyPhoneSupport from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyPhoneSupport'
import LandingPageLoyaltyTourExpCredit from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyTourExpCredit'
import LandingPageLoyaltyTravelShootCredit from 'loyalty/pages/loyaltyUserAccountPage/benefits/LandingPageLoyaltyTravelShootCredit'
import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import Plural from 'components/utils/Formatters/Plural'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'

interface Props {
  benefit: App.LoyaltyBenefit;
}

function getBenefitLabelDisplay(benefit: App.LoyaltyBenefit) {
  const { unlimited, value, remaining } = benefit
  if (unlimited) {
    return <BodyText variant="small">Unlimited</BodyText>
  }

  if (remaining === 0) {
    return <BodyText variant="small">Redeemed</BodyText>
  }

  if (value) {
    if (value.unit === 'PERCENTAGE') {
      return (
        <BodyText variant="small">
          {remaining === 1 ? '' : `${remaining}x`} {value.amount}% discount
        </BodyText>
      )
    } else if (value.unit === 'CURRENCY') {
      return (
        <BodyText variant="small">
          {remaining === 1 ? '' : `${remaining}x`} <FormatCurrency
            value={value.amount}
            format="dynamic"
          />{' '}
          <Plural count={remaining || 0} singular="voucher" />
        </BodyText>
      )
    }
  }

  return (
    <BodyText variant="small">
      {remaining}x available
    </BodyText>
  )
}

function LoyaltyAccountLandingPageBenefitItem(props: Props) {
  const { benefit } = props
  const benefitLabel = getBenefitLabelDisplay(benefit)
  const [tier] = useCurrentLoyaltyTier()

  switch (benefit.code) {
    case 'airport_transfer':
      return <LandingPageLoyaltyAirportTransfersTile key={benefit.code} tier={tier} benefit={benefit} benefitLabel={benefitLabel} />
    case 'hotel_upgrade':
      return <LandingPageLoyaltyHotelUpgrade key={benefit.code} tier={tier} benefit={benefit} benefitLabel={benefitLabel} />
    case 'lounge_pass':
      return <LandingPageLoyaltyLoungePass key={benefit.code} tier={tier} benefit={benefit} benefitLabel={benefitLabel} />
    case 'tour_exp_credit':
      return <LandingPageLoyaltyTourExpCredit key={benefit.code} tier={tier} benefit={benefit} benefitLabel={benefitLabel} />
    case 'travelshoot_credit':
      return <LandingPageLoyaltyTravelShootCredit key={benefit.code} tier={tier} benefit={benefit} benefitLabel={benefitLabel} />
    case 'discounted_insurance':
      if (!benefit.value) return null
      return <LandingPageLoyaltyDiscountedInsurance key={benefit.code} tier={tier} benefitLabel={benefitLabel} discountPercent={benefit.value.amount} />
    case 'phone_support':
      return <LandingPageLoyaltyPhoneSupport key={benefit.code} tier={tier} />
    default:
      return null
  }
}

export default LoyaltyAccountLandingPageBenefitItem
